import React from 'react'

const EXPERIENCE_DATA = [
    {
        period: 'Jul 2023 - Current',
        role: 'Software Developer',
        company: 'Open Financial Technologies',
    },
    {
        period: 'Feb 2023 - Jul 2023',
        role: 'Software Developer Intern',
        company: 'Open Financial Technologies',
    },
];

const Experience = () => {
    return (
        <div className='p-4 overflow-y-auto '>
            <h3 className='pb-4 text-lg font-semibold'>My Experience</h3>
            <ol className='relative border-l border-darkTheme-bg-tertiary'>
                {EXPERIENCE_DATA.map((item, index) => (
                    <li key={index} className='mb-5 ml-4'>
                        <div className='absolute w-3 h-3 rounded-full mt-1.5 -left-1.5 border border-darkTheme-bg-tertiary bg-darkTheme-bg-primary'></div>
                        <h3 className='text-base font-semibold text-darkTheme-fg-primary'>{item.role}</h3>
                        <p className='inline-block mb-4 text-sm font-normal text-darkTheme-fg-tertiary'>{item.company}</p>
                        <time className='mb-1 text-sm font-normal leading-none text-darkTheme-accent-primary'>{' ['}{item.period}{' ]'}</time>
                    </li>
                ))}
            </ol>
        </div>
    );
}

export default Experience